module.exports = __webpack_public_path__ + "img/nexultra-icon.4c6f77f9.svg";